import { render, staticRenderFns } from "./NewIn.vue?vue&type=template&id=2947db17&scoped=true"
import script from "./NewIn.vue?vue&type=script&lang=js"
export * from "./NewIn.vue?vue&type=script&lang=js"
import style0 from "./NewIn.vue?vue&type=style&index=0&id=2947db17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2947db17",
  null
  
)

export default component.exports